import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../api/api';
import Navbar from '../components/Navbar';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle } from '@phosphor-icons/react';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('checking');
  const [creditInfo, setCreditInfo] = useState(null);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    }
  }, [sessionId]);

  const checkPaymentStatus = async () => {
    let attempts = 0;
    const maxAttempts = 5;

    const poll = async () => {
      try {
        const response = await api.get(`/api/payments/status/${sessionId}`);
        // Refresh navbar credit badge
        window.dispatchEvent(new Event('vl:credit-refresh'));
        // Show credit applied info if present
        const credit_cents = Number(response.data.credit_applied_cents || 0);
        if (credit_cents > 0) {
          setCreditInfo({
            credit_applied_eur: credit_cents / 100,
            base_amount_eur: Number(response.data.base_amount || 0) / 100,
            final_amount_eur: Number(response.data.amount || 0) / 100,
          });
        }
        if (response.data.payment_status === 'paid') {
          setStatus('success');
          return;
        }
        attempts++;
        if (attempts < maxAttempts) {
          setTimeout(poll, 2000);
        } else {
          setStatus('success');
        }
      } catch (error) {
        console.error('Error checking payment:', error);
        setStatus('success');
      }
    };

    poll();
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="flex items-center justify-center px-4 py-20">
        <Card className="w-full max-w-md p-8 neumorphism rounded-2xl text-center" data-testid="payment-success">
          {status === 'checking' ? (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
              <h2 className="font-heading font-semibold text-2xl mb-2">Verifica pagamento...</h2>
              <p className="text-foreground/70">Stiamo confermando il tuo pagamento</p>
            </>
          ) : (
            <>
              <div className="w-20 h-20 bg-sky-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle size={48} className="text-sky-600" weight="fill" />
              </div>
              <h2 className="font-heading font-semibold text-3xl mb-4">Pagamento Completato!</h2>
              <p className="text-foreground/70 mb-4">
                Il tuo pagamento è stato elaborato con successo. Riceverai una conferma via email.
              </p>
              {creditInfo && (
                <div className="mb-6 p-4 bg-primary/10 border border-primary/30 rounded-lg text-sm text-left" data-testid="credit-applied-info">
                  <div className="flex justify-between mb-1">
                    <span className="text-foreground/70">Importo base:</span>
                    <span className="font-mono">€{creditInfo.base_amount_eur.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between mb-1 text-primary">
                    <span>Credito applicato:</span>
                    <span className="font-mono font-semibold">-€{creditInfo.credit_applied_eur.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between pt-2 border-t border-primary/20 font-semibold">
                    <span>Pagato:</span>
                    <span className="font-mono">€{creditInfo.final_amount_eur.toFixed(2)}</span>
                  </div>
                </div>
              )}
              <Button
                onClick={() => navigate('/dashboard')}
                className="rounded-full"
                data-testid="go-to-dashboard-btn"
              >
                Vai alla Dashboard
              </Button>
            </>
          )}
        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;